// @core/api/endpoints/notifications/set_notifications_read_all.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  SetNotificationsReadAllRequest,
} from '../../../types/notifications';

const BASE_PATH = '/notifications';

/**
 * Mark all notifications as read
 * Marks all unread notifications for the specified user as read in a single operation. Useful for clearing notification backlogs.
 */
export async function SetNotificationsReadAll(
  user_id: string,
  data: SetNotificationsReadAllRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/users/:user_id/notifications/read-all`;
  requestPath = requestPath.replace(':user_id', encodeURIComponent(user_id));
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
